import { render, staticRenderFns } from "./OmJohker.vue?vue&type=template&id=3f94b44e"
import script from "./OmJohker.vue?vue&type=script&lang=js"
export * from "./OmJohker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports